import React from 'react';
import { IoArrowBack } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

interface BackProps {
  path?: string;
  text: string;
}

const GoBack: React.FC<BackProps> = ({ path = '/dashboard', text }) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex items-center gap-2 bg-gray-100 rounded-lg mb-4 px-4 py-2 text-xs w-fit cursor-pointer"
      onClick={() => navigate(path)}
    >
      <IoArrowBack />
      <p>{text}</p>
    </div>
  );
};

export default GoBack;
